import React, { Component } from 'react';
import classNames from 'classnames';
import RTE from 'shared/components/rte/rte';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const ScrollDown = 40;
// const ScrollUp = 38;

/**
 * RTE Editor
 */
class RTEEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this._scrollDirection = ScrollDown;
    this._cursorAutoScroll = false;

    this._handleClick = this._handleClick.bind(this);
    this.isScrolling = null;
  }

  render() {
    const {
      height,
      rteState,
      onExternalContentChange,
      onStopEdit,
      onWillUnmount,
      wrapperClassName,
      isEditing,
      zoom,
      lineHeight,
      placeholder,
      scrollTop,
      onScroll,
      viewType,
      toolbarStyle,
    } = this.props;

    return (
      <div
        aria-label="RTE Editor"
        className={classNames('rte-featured', {
          'rte-featured-editing': isEditing,
        })}
        ref={(ref) => (this._outerContainer = ref)}
        onClick={this._handleClick}
      >
        <div className="rte-featured-editor">
          <RTE
            readOnly={!isEditing}
            toolbarStyle={toolbarStyle}
            scrollTop={scrollTop}
            onScroll={onScroll}
            height={height}
            minHeight={height - 60}
            displayToolbar
            toolbarOnFocus={false}
            autoFocus
            rteState={rteState}
            resize={false}
            onExternalContentChange={onExternalContentChange}
            wrapperClassName={wrapperClassName}
            onContentChange={onStopEdit}
            viewType={viewType}
            disableBlur
            editorClassName={isEditing ? 'rte-editor-editing' : ''}
            zoom={zoom}
            lineHeight={lineHeight}
            placeholder={placeholder}
            onWillUnmount={onWillUnmount}
          />
        </div>
      </div>
    );
  }

  _handleClick() {
    const {
      isEditing,
      isSelected,
      onSelect,
      onStartEdit,
      corrupted,
    } = this.props;

    if (!isEditing && !isSelected) {
      onSelect();
    } else if (isSelected && !isEditing) {
      //Prevent user from going into edit mode of corrupted cells.
      if (!corrupted) onStartEdit();
    }
  }
}

RTEEditor.defaultProps = {
  placeholder: '',
  scrollTop: 0,
};

RTEEditor.propTypes = {
  isEditing: React.PropTypes.bool,
  isSelected: React.PropTypes.bool,
  wrapperClassName: React.PropTypes.string,
  onSelect: React.PropTypes.func.isRequired,
  onStartEdit: React.PropTypes.func.isRequired,
  onStopEdit: React.PropTypes.func.isRequired,
  onExternalContentChange: React.PropTypes.func,
  rteState: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.string,
  ]),
  placeholder: React.PropTypes.string,
  minHeight: React.PropTypes.number,
  scrollTop: React.PropTypes.number,
  onScroll: React.PropTypes.func,
};

export default RTEEditor;
